import React from 'react';
import { Award, Clock } from 'lucide-react';
import { instructors } from '../data/mock';

const Instructors = () => {
  return (
    <section className="py-24 bg-bg-card">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 text-brand-primary mb-4">
            Professores de Verdade
          </h2>
          <p className="body-medium text-gray-400 max-w-3xl mx-auto">
            Instrutores qualificados, experientes e apaixonados pelo que fazem. Seu sucesso é o nosso sucesso.
          </p>
        </div>

        {/* Instructors Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {instructors.map((instructor) => (
            <div
              key={instructor.id}
              className="group glass-card border-white/5 rounded-xl overflow-hidden hover:border-brand-primary"
            >
              {/* Image */}
              <div className="relative aspect-[3/4] sm:aspect-square md:h-80 overflow-hidden">
                <img
                  src={instructor.image}
                  alt={instructor.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="heading-4 text-brand-primary mb-1">
                  {instructor.name}
                </h3>
                <p className="body-small text-secondary-yellow mb-4">
                  {instructor.title}
                </p>

                {/* Credentials */}
                <div className="space-y-2 mb-4">
                  <div className="flex items-center space-x-2">
                    <Clock className="w-4 h-4 text-brand-primary" />
                    <span className="caption text-gray-400">{instructor.experience}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Award className="w-4 h-4 text-brand-primary" />
                    <span className="caption text-gray-400">{instructor.credentials}</span>
                  </div>
                </div>

                <p className="body-small text-gray-400">
                  {instructor.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Instructors;
